module.exports = __webpack_public_path__ + "img/ic_contact.0cb3336c.svg";